import moment from 'moment'

moment.locale('ru')

// Наименование периода у индивидуальной работы номера пары не содержит
// («инд. раб.» против «1-2»); в дне такая строка идёт последней (п. 5.7 ТЗ).
const isIndividual = name => !/\d/.test(String(name || ''))

// «09:00-10:30» → 540. Порядок пар в дне задаётся временем начала: строковая
// сортировка наименований ставит «10-11» перед «3-4».
const startMinutes = time => {
  const parsed = /(\d{1,2}):(\d{2})/.exec(String(time || ''))
  return parsed ? Number(parsed[1]) * 60 + Number(parsed[2]) : Number.MAX_SAFE_INTEGER
}

const filled = value => value !== null && value !== undefined && String(value).trim() !== ''

// Занятие из строки расписания. Заготовки без дисциплины (cid = 0) сервер
// отдаёт с пустыми course_alias/course_title — в сетке это пустая ячейка.
const toLesson = raw => {
  const alias = raw.course_alias || raw.course_title
  if (!filled(alias)) return null

  return {
    alias,
    typeAlias: raw.lessontype_alias || '',
    // в окне — головная дисциплина, при её отсутствии дисциплина РПД (п. 7.3.1 ТЗ)
    discipline: raw.meta_course_name || raw.course_title || '',
    typeName: raw.lessontype_name || '',
    themeNumber: [raw.subject_index, raw.tema_num].filter(filled).join('.'),
    themeTitle: raw.subject_title || '',
    // перечни, а не строки: разделителя внутри teachers/rooms нет (п. 6.2.2 ТЗ)
    rooms: raw.array_rooms || [],
    teachers: raw.array_teachers || [],
  }
}

// Колонки групп. Порядок задаёт сервер (перечень групп отбора, ORDER BY name);
// группы, попавшие в расписание, но отсутствующие в перечне, дописываются в конец.
export const buildColumns = (groupList, schedule, groupId) => {
  const columns = []
  const seen = new Set()

  const add = (id, name) => {
    if (id === null || id === undefined || seen.has(String(id))) return
    seen.add(String(id))
    columns.push({ id, name: name || '' })
  }

  ;(groupList || []).forEach(group => add(group.gid, group.name || group.groupname))
  eachLesson(schedule, raw => add(raw.group_id, raw.groupname))

  return groupId ? columns.filter(column => String(column.id) === String(groupId)) : columns
}

function eachLesson(schedule, callback) {
  Object.keys(schedule || {}).forEach(date => {
    const periods = schedule[date] || {}
    Object.keys(periods).forEach(periodName => {
      (periods[periodName] || []).forEach(entry => {
        const raw = Array.isArray(entry) ? entry[0] : entry
        if (raw) callback(raw, date, periodName)
      })
    })
  })
}

// Дни расписания: день → строки пар → ячейки по идентификатору группы.
export const buildDays = schedule => {
  const today = moment().format('YYYY-MM-DD')

  return Object.keys(schedule || {})
    .sort()
    .map(date => {
      const periods = schedule[date] || {}
      const day = moment(date, 'YYYY-MM-DD')
      const weekday = day.isoWeekday()

      const rows = Object.keys(periods).map(periodName => {
        const cells = {}
        let periodTime = ''

        ;(periods[periodName] || []).forEach(entry => {
          const raw = Array.isArray(entry) ? entry[0] : entry
          if (!raw) return
          if (!periodTime && raw.period_time) periodTime = raw.period_time
          const lesson = toLesson(raw)
          if (lesson && !cells[raw.group_id]) cells[raw.group_id] = lesson
        })

        return {
          periodName,
          periodTime,
          individual: isIndividual(periodName),
          cells,
        }
      })

      rows.sort((a, b) => (a.individual - b.individual)
        || (startMinutes(a.periodTime) - startMinutes(b.periodTime)))

      return {
        date,
        dayNumber: day.format('D MMMM'),
        weekdayShort: day.format('dd'),
        isWeekend: weekday >= 6,
        isToday: date === today,
        rows,
      }
    })
}

const PLURAL = {
  rooms: ['аудитория', 'аудитории', 'аудиторий'],
  teachers: ['преподаватель', 'преподавателя', 'преподавателей'],
}

export const pluralize = (count, kind) => {
  const forms = PLURAL[kind]
  const tail = count % 10
  const hundred = count % 100
  if (tail === 1 && hundred !== 11) return forms[0]
  if (tail >= 2 && tail <= 4 && (hundred < 10 || hundred >= 20)) return forms[1]
  return forms[2]
}
